const getters = {
  userInfo: (state) => state.user.info,
  permissionRoutes: (state) => state.permission.routes,
};

export default getters;
